import { Space } from 'lucide-react';
import type { SpacerBlock } from '@impact/types';
import type { BlockTypeConfig } from '../types';

export const spacerConfig: BlockTypeConfig<SpacerBlock> = {
  type: 'spacer',
  label: 'Spacer',
  description: 'Vertical spacing between content blocks',
  icon: Space,
  category: 'layout',
  createDefault: () => ({
    height: 'md',
  }),
  toolbar: [
    {
      kind: 'select',
      path: 'data.height',
      label: 'Height',
      options: [
        { value: 'sm', label: 'Small' },
        { value: 'md', label: 'Medium' },
        { value: 'lg', label: 'Large' },
        { value: 'xl', label: 'Extra Large' },
      ],
    },
    { kind: 'variant' },
    { kind: 'divider' },
    { kind: 'more' },
  ],
  sheet: [],
};
